//#region types
import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";
//#endregion
import useAPIClientHelper from "./useAPIClientHelper";

function useSupplementaryMaterialService() {
  const { apiClientInstance } = useAPIClientHelper();

  //#region Todo
  const submitSupplementaryMaterial = (
    id: number,
    explanation: string,
    attachmentsToUpload: ApiModels.SupplementaryMaterialAttachment[]
  ) => {
    const supplementaryMaterialPut: ApiModels.SupplementaryMaterialPut = {
      answer: explanation,
      attachments: attachmentsToUpload,
    };

    return apiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: true,
    }).SupplementaryMaterialsClient.Put(id, supplementaryMaterialPut);
  };

  //#endregion

  const getTodoType = (sourceType?: ApiModels.SupplementaryMaterialSourceType) => {
    switch (sourceType) {
      case ApiModels.SupplementaryMaterialSourceType.IncomingInvoice:
        return ApiModels.TodoType.IncomingInvoice;
      case ApiModels.SupplementaryMaterialSourceType.CustomerReceipt:
        return ApiModels.TodoType.Receipt;
      default:
        return undefined;
    }
  };
  return { submitSupplementaryMaterial, getTodoType };
}

export default useSupplementaryMaterialService;
